<template>
  <div>
    <!-- BEGIN #top-nav -->
    <div id="top-nav" class="top-nav">
      <!-- BEGIN container -->
      <div class="container">
        <div class="collapse navbar-collapse">
          <!--ul class="nav navbar-nav">
            <li class="dropdown dropdown-hover">
              <a href="#" data-toggle="dropdown"><img src="../assets/color-theme/img/flag/flag-english.png" class="flag-img" alt="" /> English <i class="fa fa-angle-down"></i></a>
              <ul class="dropdown-menu">
                <li><a href="#"><img src="../assets/color-theme/img/flag/flag-english.png" class="flag-img" alt="" /> English</a></li>
              </ul>
            </li>
            <li><a href="#">Customer Care</a></li>
            <li><a href="#">Order Tracker</a></li>
          </ul -->
          <ul class="nav navbar-nav navbar-right">
            <li><a href="/beta/contact-us">Contact us</a></li>
            <li><a href="#"><i class="fa fa-facebook f-s-14"></i></a></li>
            <li><a href="#"><i class="fa fa-twitter f-s-14"></i></a></li>
            <li><a href="#"><i class="fa fa-linkedin f-s-14"></i></a></li>
          </ul>
        </div>
      </div>
      <!-- END container -->
    </div>
    <!-- END #top-nav -->
    <div id="header" class="header">
      <div class="container">
        <div class="header-container">
          <!-- BEGIN navbar-header -->
          <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse">
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <div class="header-logo">
              <a href="/beta/">
                  <span class="brand"></span>
                  <span>womia</span>.play
                  <small>Medical Apps Sharing Platform</small>
              </a>
            </div>
          </div>
          <!-- END navbar-header -->
          <!-- BEGIN header-nav -->
          <div class="header-nav">
            <ul class="nav pull-right">
              <li v-if="!isAuthenticated">
                <router-link :to="{name: 'Signup'}" class="btn btn-womia m-r-20">Create account</router-link>
              </li>
              <li v-if="!isAuthenticated">
                <router-link :to="{name: 'Login'}" class="btn">Login</router-link>
              </li>
              <li v-if="isAuthenticated && !hasRole(['admin'])">
                <a href="#" class="nav-item nav-link dropdown-toggle mr-md-2" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img v-if="!currentUser.picture" src="/beta/static/default-user-128.png" class="user-img" width="128" height="128" alt="">
                <img v-if="currentUser.picture" :src="currentUser.picture.slug | media({width: '128'})" class="user-img" alt="">
                <span class="hidden-md hidden-sm hidden-xs">{{ currentUser.nickname || currentUser.email }}</span> <b class="caret"></b>
              </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="bd-versions">
                  <router-link class="dropdown-item" :to="{ name: 'Profile'}">My Profile</router-link>
                  <router-link class="dropdown-item" :to="{ name: 'Home', query: {search: 'MyApps'}}">My Downloads</router-link>
                  <router-link class="dropdown-item" :to="{ name: 'DashboardDeveloper'}">Developer dashboard</router-link>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" href="#logout" @click="logoutGoHome()">Log out</a>
                </div>
              </li>
              <li v-if="isAuthenticated && hasRole(['admin'])">
                <router-link class="btn btn-primary mr-md-4" :to="{ path: '/beta/admin/product'}">Return to App Management <i class="fa fa-arrow-right pl-2"></i></router-link>
              </li>
            </ul>
          </div>
          <!-- END header-nav -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuex from 'vuex'

export default {
  name: 'navbar',
  methods: {
    ...Vuex.mapActions(['login', 'logout']),
    logoutGoHome() {
      this.logout()
      this.$router.push({ path: '/' })
    }
  },
  computed: {
    ...Vuex.mapGetters(['isAuthenticated', 'currentUser', 'isLoading', 'hasRole'])
  }
}
</script>
<style>
.header-logo {
  width: 500px;
}


/*
.header-logo small {
  margin: 17px 0 0 10px;
  position: absolute;
}
*/
.header-logo .brand {
    float: left;
    height: 45px;
    width: 45px;
    border: none !important;
    margin: 8px 12px;
    border-radius: 0;
    box-shadow: none;
    background-image: url("/beta/static/logo.svg");
    background-size: contain;
    background-repeat: no-repeat;
}
.header-nav .nav>li>a.btn {
  line-height: inherit;
}

.header .navbar-nav>li>.dropdown-menu {
  margin-top: 0;
  border-top: 1px solid #f2f3f4;
  box-shadow: 0 13px 25px -2px rgba(0, 0, 0, .2);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.header .dropdown-menu {
  padding: 10px;
  min-width: 100px;
}

.dropdown-item,
.dropdown-menu>li>a {
  display: block;
  padding: 5px 15px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  text-decoration: none;
}

.dropdown-divider,
.dropdown-menu .divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue